<script>
import DaylogService from "@/services/DaylogService";
import HalfDashCard from "@/components/Cards/HalfDashCard";
import dayjs from "dayjs";

export default {
    props: {
        selectedDate: {},
        what: { type: String }
    },
    components: { HalfDashCard },
    data() {
        return {
            loading: true,
            mdata: {},
            meta: {}
        };
    },
    computed: {
        day() {
            if (this.loading) {
                return null;
            }

            return this.mdata[this.selectedDate]["daylog"];
        },
        total_absence() {
            return (
                parseInt(this.day.absence_sick_time) +
                parseInt(this.day.absence_others) +
                parseInt(this.day.absence_holiday_time)
            );
        },
        total_time() {
            const sum =
                (this.day.work_time === null
                    ? 0
                    : parseInt(this.day.work_time)) + this.total_absence;
            return sum;
        },
        balance() {
            return this.total_time - this.day.goal_time;
        }
    },
    async created() {
        await this.fetchData();
        this.loading = false;
    },
    methods: {
        async fetchData() {
            try {
                const ds = dayjs(this.selectedDate);
                const { data } = await DaylogService.GET_myData(
                    ds.format("YYYY"),
                    ds.format("M")
                );
                this.mdata = data.data;
                this.meta = data.meta;
            } catch (e) {
                console.log("fd e", e);
            }
        }
    }
};
</script>

<template>
    <span>
        <v-loader :loading="loading" v-if="loading" />
        <template v-else>
            <template v-if="what === 'time'">
                <template v-if="day">
                    {{ day.work_time | toTime }}
                </template>
                <template v-else>---</template>
            </template>
            <template v-if="what === 'absence'">
                <template v-if="day">
                    {{ total_absence | toTime }}
                </template>
                <template v-else>---</template>
            </template>
        </template>
    </span>
</template>

<style lang="scss"></style>
